export default "__VITE_ASSET__C3Fg2b$X__"